import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-wacom-tablet",
  "use": "icon-si-glyph-wacom-tablet-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-wacom-tablet\" id=\"icon-si-glyph-wacom-tablet\"><title>1035</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0,5 L0,14 L16,14 L16,5 L0,5 L0,5 Z M5,7 L5,12 L14,12 L14,7 L5,7 L5,7 Z M0.959,7 L2,7 L2,8 L0.959,8 L0.959,7 L0.959,7 Z M2,12 L0.959,12 L0.959,11 L2,11 L2,12 L2,12 Z M0.953,10 L0.953,8.979 L2.953,8.979 L2.953,10 L0.953,10 Z M15,13 L4,13 L4,6 L15,6 L15,13 L15,13 Z\" fill=\"#434343\" class=\"si-glyph-fill\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-wacom-tablet.svg
// module id = g1I/
// module chunks = 62